import type { LocationConfig } from './location-config-types';
import { babcockRanchConfig } from '../locations/babcock-ranch/location.config';

/**
 * Location config resolver.
 *
 * TODAY: babcock-ranch is the only location, so we export it directly.
 * FUTURE: when a second location is added, read a build-time env var
 * (e.g. VITE_LOCATION_SLUG for frontend, LOCATION_SLUG for worker) and
 * dispatch to the correct config object. Components MUST NOT import
 * `babcockRanchConfig` directly — always import `locationConfig` from
 * this module so a slug swap is a one-file change.
 */
export const locationConfig: LocationConfig = babcockRanchConfig;

export type { LocationConfig } from './location-config-types';
